// extracted by mini-css-extract-plugin
export default {"mainContainer":"style_mainContainer__KIniX","input":"style_input__Aj0xS","textEditorContainer":"style_textEditorContainer__BlIEJ"};